export const GET_PHOTOS = 'GET_PHOTOS';

export const fetchPhotos = data => ({
    type: GET_PHOTOS,
    data,
})